/* istanbul ignore file */
import React from 'react';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import ShoppingCampaignCreationView from '@bingads-webui-campaign-legacy/shopping-campaign/view/campaign-creation/index';
import { useJsDataContext } from '@bingads-webui-cc-react/js-data-rest';
import { useShoppingFAC } from '@bingads-webui-campaign-react/shopping-coupon-callout';
import { getEntityCreationStyle } from '../styles';
import { InjectWrapperWithHoC, withCreationHeader } from '../helper';

const getShoppingCampaignCreationComponent = isMSStoreAdsGAWorkflow => (props) => {
  const ccJsData = useJsDataContext();
  const { perfMarker, scope, siteMap } = props;
  const {
    getFACCoupon,
    updateCouponStatus,
  } = useShoppingFAC({
    scope,
    siteMap,
  });

  return (
    <div className="search-shopping-campaign-creation">
      <InjectWrapperWithHoC
        {...props}
        InjectViewFactory={() => Promise.resolve(ShoppingCampaignCreationView)}
        InjectViewOption={{
          perfMarker,
          isMSStoreAdsGAWorkflow,
          ccJsData,
          scope,
          siteMap,
          getFACCoupon,
          updateCouponStatus,
        }}
        styleScopeName="CampaignCreationSearchShopping"
      />
    </div>
  );
};

const CampaignCreationSearchShopping = getShoppingCampaignCreationComponent(false);
const CampaignCreationMSStoreAds = getShoppingCampaignCreationComponent(true);

const propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      CurrencyCode: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
  scope: PropTypes.shape({}).isRequired,
  siteMap: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

CampaignCreationSearchShopping.propTypes = propTypes;
CampaignCreationMSStoreAds.propTypes = propTypes;

export const StyledCampaignCreationSearchShopping =
  withDefaultStyles(withCreationHeader(CampaignCreationSearchShopping), getEntityCreationStyle);
export const StyledCampaignCreationMSStoreAds =
  withDefaultStyles(withCreationHeader(CampaignCreationMSStoreAds), getEntityCreationStyle);
